import { render, staticRenderFns } from "./AddEditDesignerSectionModal.vue?vue&type=template&id=15cd20e0&scoped=true"
import script from "./AddEditDesignerSectionModal.vue?vue&type=script&lang=js"
export * from "./AddEditDesignerSectionModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditDesignerSectionModal.vue?vue&type=style&index=0&id=15cd20e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd20e0",
  null
  
)

export default component.exports